// extracted by mini-css-extract-plugin
module.exports = {"card":"SearchCategoryItem_card__C0iw9"};